import { render, staticRenderFns } from "./ARequestItem.vue?vue&type=template&id=23a60bdc&scoped=true"
import script from "./ARequestItem.vue?vue&type=script&lang=js"
export * from "./ARequestItem.vue?vue&type=script&lang=js"
import style0 from "./ARequestItem.vue?vue&type=style&index=0&id=23a60bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a60bdc",
  null
  
)

export default component.exports